// import React, { useState } from "react";
// import { SIGNUP_FORM_BASIC } from "../utils/constant";
// import m3_logo from "../assets/logos/M3_Logo.png";
// import GradientButton from "../Components/Button/GradientButton";
// import FormItem from "../Components/Interactions/FormItem";
// import CurrentInput from "../Components/CurrentInput/CurrentInput";
// import { Form } from "antd";
// import { Link, useNavigate } from "react-router-dom";
// import RequestSendModal from "../Components/AllModal/RequestSentModal";
// import { CognitoUser, CognitoUserAttribute } from "amazon-cognito-identity-js";
// import { userPool } from "../utils/aws";
// import toastMessage from "../utils/toastMessage";
// import EmailConfirmModal from "../Components/AllModal/EmailConfirmModal";
// import { LoadingOutlined } from "@ant-design/icons";
// import checkEmailVerifyOrNot from "../Components/AllModal/checkEmailVerified";
// import AwsResetOtp from "../utils/AWS/resendOtp";
// import MoveOnModal from "../Components/AllModal/MoveOnModal";
// import dayjs from "../utils/myDayjs";

// const TABS_DATA = [
//   "Basic Information",
//   "Education Information",
//   "Professional Experience",
// ];
// const Register = () => {
//   const navigate = useNavigate();
//   const [form] = Form.useForm();
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState({ signUpLoading: false });
//   const [emailVerificationModal, setEmailVerificationModal] = useState(false);
//   const [emailVerifiedModal, setEmailVerifiedModal] = useState(false);
//   const [requestSendModal, setRequestSendModal] = useState(false);
//   const [tabsForm, setTabsForm] = useState(SIGNUP_FORM_BASIC);
//   const [currentTabs, setCurrentTabs] = useState(TABS_DATA[0]);
//   const [cities, setCities] = useState([]);

//   const onCountryChange = (value) => {
//     const selectedCountry = countriesData.find(
//       (country) => country.key === value
//     );
//     if (selectedCountry) {
//       setCities(selectedCountry.cities);
//       // If you want to reset the city field when country changes
//       form.setFieldsValue({ city: "" });
//     } else {
//       setCities([]);
//     }
//   };

//   const handleCheckEmailVerifiedOrNot = (error, confirm, email) => {
//     setLoading((prev) => ({ ...prev, signUpLoading: false }));
//     if (error === "NotVerify") {
//       AwsResetOtp(email);
//       toastMessage(
//         "Your email is not confirm yet, an Otp has been send to your email",
//         "info"
//       );
//       console.log(error, "handleCheckEmailVerifiedOrNot");
//       setEmailVerificationModal(true);
//     }
//     if (confirm) {
//       // toastMessage('Your email is Verified, Please ', "info");
//       setEmailVerifiedModal(true);
//       console.log(confirm, "handleCheckEmailVerifiedOrNot");
//     }
//   };

//   const getEducationalInfo = (data) => {
//     console.log(data);
//     const result = [];
//     let i = 0;

//     while (true) {
//       const entry = {
//         instituteName: data[`instituteName${i}`],
//         qualificationType: data[`qualificationType${i}`],
//         programName: data[`programName${i}`],
//         startDate: dayjs(data[`startDate${i}`]).utc().format(),
//         endDate: dayjs(data[`endDate${i}`]).utc().format(),
//       };

//       // Check if the entry is valid (has an instituteName)
//       if (!entry.instituteName) {
//         break;
//       }

//       result.push(entry);
//       i++;
//     }

//     return result;
//   };

//   const getProfessionalInfo = (data) => {
//     console.log(data);
//     const result = [];
//     let i = 0;

//     while (true) {
//       const entry = {
//         companyName: data[`companyName${i}`],
//         employementType: data[`employementType${i}`],
//         city: data[`selectCity${i}`],
//         title: data[`title${i}`],
//         startDate: dayjs(data[`startDate${i}`]).utc().format(),
//         endDate: dayjs(data[`endDate${i}`]).utc().format(),
//       };

//       // Check if the entry is valid (has an instituteName)
//       if (!entry.companyName) {
//         break;
//       }

//       result.push(entry);
//       i++;
//     }

//     return result;
//   };

//   const hadleCreateUserInCognito = (values) => {
//     setLoading((prev) => ({ ...prev, signUpLoading: true }));
//     const { name, email, password, confirmPassword, dob, phone, ...rest } = values["Basic_Information"];

//     let dataBasicInfo = {
//       Name: "custom:basic_info",
//       Value: JSON.stringify({
//         role: "talent",
//         phone,
//         dob: dayjs(dob).utc().format(),
//         ...rest,
//       }),
//     };

//     // const educational_info = getEducationalInfo(
//     //   values["Education_Information"]
//     // );
//     // const professional_exp = getProfessionalInfo(
//     //   values["Professional_Experience"]
//     // );

//     let dataName = { Name: "name", Value: name };
//     let dataEmail = { Name: "email", Value: email };
//     // let dataPhone = { Name: "phone_number", Value: phone };
//     // let dataEducInfo = {
//     //   Name: "custom:educational_info",
//     //   Value: JSON.stringify(educational_info),
//     // };
//     // let dataProfInfo = {
//     //   Name: "custom:professional_exp",
//     //   Value: JSON.stringify(professional_exp),
//     // };

//     // attributeList.push(attributeEmail);
//     let attributeList = [
//       new CognitoUserAttribute(dataName),
//       new CognitoUserAttribute(dataEmail),
//       // new CognitoUserAttribute(dataPhone),
//       // new CognitoUserAttribute(dataBasicInfo),
//       // new CognitoUserAttribute(dataEducInfo),
//       // new CognitoUserAttribute(dataProfInfo),
//     ];

//     userPool.signUp(
//       email,
//       password,
//       attributeList,
//       null,
//       function (err, result) {
//         if (err) {
//           console.log(err);
//           toastMessage(err.message, "error");
//           checkEmailVerifyOrNot(email, password, handleCheckEmailVerifiedOrNot);
//           // setLoading(prev => ({ ...prev, signUpLoading: false, }));
//           return;
//         }
//         var cognitoUser = result.user;
//         console.log(cognitoUser, "cognitoUser");
//         console.log("user name is " + cognitoUser.getUsername());
//         // setCurrentTabs(TABS_DATA[1])
//         localStorage.setItem("m3_user_id", cognitoUser.getUsername());
//         toastMessage("Successfully Signup", "success");
//         setEmailVerificationModal(true);
//         setLoading((prev) => ({ ...prev, signUpLoading: false }));
//         // setTimeout(()=>{
//         // }, 500);
//         // toastMessage("Enter verification code to activate account", "info");
//       }
//     );
//   };

//   const handleChange = (name, value) => {
//     form.setFieldsValue({ [name]: value });
//   };

//   const handleAddEducation = () => {
//     const data = { ...tabsForm };
//     data[currentTabs] = [...data[currentTabs], data[currentTabs][0]];
//     setTabsForm(data);
//   };

//   const handleTabsBack = (i) => {
//     let oldData = formData[TABS_DATA[i]];
//     // console.log(oldData, "oldData");
//     form.setFieldsValue({ ...oldData });
//     setCurrentTabs(TABS_DATA[i]);
//   };

//   // FInal Submit For Registration
//   const handleFinish = (values) => {
//     let currTabKey = currentTabs.replace(" ", "_");
//     let index = TABS_DATA.indexOf(currentTabs);
//     setFormData((prev) => ({ ...prev, [currTabKey]: values }));
//     if (index === 2) {
//       let userData = { ...formData, [currTabKey]: values };
//       console.log(userData);
//       hadleCreateUserInCognito(userData);
//     } else {
//       setCurrentTabs(TABS_DATA[index + 1]);
//     }
//     // if(index === 0){
//     //   setLoading(prev => ({ ...prev, signUpLoading: true, }));
//     //   hadleCreateUserInCognito(values);
//     // }
//     // else if(index === 1){
//     //   setCurrentTabs(TABS_DATA[index+1])
//     // }
//     // else if(index === 2){
//     //   // axios.post("https://5lkru1km8h.execute-api.us-east-2.amazonaws.com/Stage/user", );
//     //   setRequestSendModal(true);
//     // }
//   };

//   // console.log(formData[currentTabs], "formData[currentTabs]");
//   const hadleMoveToLoginPage = () => {
//     setEmailVerifiedModal(false);
//     navigate("/signin");
//   };

//   return (
//     <div className="registerContainer relative flex flex-col items-center pb-8 sm:pb-4">
//       <RequestSendModal
//         open={requestSendModal}
//         onOk={() => {}}
//         onCancel={() => setRequestSendModal(false)}
//       />
//       <MoveOnModal
//         open={emailVerifiedModal}
//         onOk={() => {}}
//         onCancel={() => setEmailVerifiedModal(false)}
//       >
//         <div
//           className={`modalConatainerBg w-[350px] sm:w-[500px] min-h-[300px] rounded-xl flex flex-col items-center`}
//         >
//           <div className="flex flex-col justify-center items-center mt-16">
//             <p className="text-3xl font-satoshi">
//               Your Email Already Registered
//             </p>
//             <p className="mt-8 px-11 text-center text-lg">
//               You have already registered this email, please move to the Signin
//               page and Signin to visit our website
//             </p>
//             <GradientButton
//               onClick={hadleMoveToLoginPage}
//               className="py-[8px] px-8 mt-8 shadow-lg"
//             >
//               Login
//             </GradientButton>
//           </div>
//         </div>
//       </MoveOnModal>
//       <EmailConfirmModal
//         open={emailVerificationModal}
//         onOk={() => {}}
//         onCancel={() => setEmailVerificationModal(false)}
//         email={formData["Basic_Information"]?.email}
//         onEmailVerification={() => navigate("/signin")}
//       />
//       <div className="m3_logo_register absolute top-6 left-6">
//         <img src={m3_logo} width={100} />
//       </div>
//       <div className="mt-24 gap-x-5 hidden sm:flex items-center md:w-[700px] md:justify-between md:mb-10">
//         {TABS_DATA?.map((tabName, i) => {
//           {
//             /* let currTabIndex = TABS_DATA.indexOf(currentTabs); */
//           }
//           if (tabName === currentTabs) {
//             return (
//               <GradientButton key={tabName} className="py-[6px]">
//                 {tabName}
//               </GradientButton>
//             );
//           }
//           return (
//             <p
//               key={tabName}
//               className={`text-white cursor-not-allowed`}
//               // onClick={i > currTabIndex ? ()=>{} : ()=>handleTabsBack(i)}
//             >
//               {tabName}
//             </p>
//           );
//         })}
//       </div>
//       <div className="mt-24 gap-x-5 flex sm:hidden items-center">
//         <GradientButton className="py-[6px]">{currentTabs}</GradientButton>
//       </div>
//       {/* initialValues={{ ...formData[currentTabs] }} */}
//       <Form
//         onFinish={handleFinish}
//         form={form}
//         initialValues={{ ...formData[currentTabs.replace(" ", "_")] }}
//         className="w-full mt-8 flex flex-col items-center sm:flex-row sm:justify-center sm:flex-wrap md:justify-between 2xl::justify-start md:w-[680px] gap-x-4 md:gap-x-8 gap-y-5"
//       >
//         {currentTabs === "Basic Information"
//           ? tabsForm[currentTabs]?.map((data, i) => (
//               <FormItem
//                 key={i}
//                 className={`w-full px-5 sm:px-0 sm:w-[310px] md:w-[320px] ${data.className}`}
//                 name={data.name}
//                 rules={data.rules}
//                 dependencies={data?.dependencies}
//               >
//                 <CurrentInput
//                   data={data}
//                   // onChange={handleChange}
//                 />
//               </FormItem>
//             ))
//           : null}

//         {currentTabs === "Education Information" ||
//         currentTabs === "Professional Experience"
//           ? tabsForm[currentTabs]?.map((eachEducation, index) => {
//               return (
//                 <div
//                   key={index}
//                   className="pb-2 w-full flex flex-col items-center sm:flex-row sm:justify-center sm:flex-wrap md:justify-between 2xl::justify-start md:w-[680px] gap-x-4 md:gap-x-8 gap-y-5"
//                 >
//                   {eachEducation.map((data) => {
//                     return (
//                       <FormItem
//                         key={data.id}
//                         className={`w-full px-5 sm:px-0 sm:w-[310px] md:w-[320px] ${data.className}`}
//                         name={data.name + index}
//                         rules={data.rules}
//                       >
//                         <CurrentInput data={data} onChange={handleChange} />
//                       </FormItem>
//                     );
//                   })}
//                   {tabsForm[currentTabs]?.length - 1 > index && (
//                     <div className="w-full flex justify-center items-center gap-x-5 mt-2">
//                       {[1, 2, 3, 4, 5].map((x) => (
//                         <div
//                           key={x}
//                           className="w-2 h-2 bg-lightOrange rounded-full"
//                         ></div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               );
//             })
//           : null}
//         {currentTabs === "Education Information" ||
//         currentTabs === "Professional Experience" ? (
//           <div className="w-full">
//             <GradientButton
//               type="button"
//               className="px-10 rounded-lg py-[6px]"
//               onClick={handleAddEducation}
//             >
//               Add
//             </GradientButton>
//           </div>
//         ) : null}
//         <div className="w-full flex justify-between items-center">
//           <Link to="/signin" className="text-gray-200 hover:text-lightOrange">
//             Already have an Account?
//           </Link>
//           <GradientButton
//             disabled={loading.signUpLoading}
//             className={`px-14`}
//             type="submit"
//           >
//             <span>Submit</span>{" "}
//             {loading.signUpLoading && (
//               <LoadingOutlined style={{ fontSize: 16, marginLeft: "8px" }} />
//             )}
//           </GradientButton>
//         </div>
//       </Form>
//     </div>
//   );
// };

// export default Register;
import React, { useState } from "react";
import m3_logo from "../assets/images/M3_Logo.svg";
import {
  Button,
  Checkbox,
  ConfigProvider,
  Divider,
  Form,
  Input,
  Select,
} from "antd";
import { Google_original, Linkedin_original } from "../utils/icons";
import { useNavigate } from "react-router-dom";
import GradientButton from "../Components/Button/GradientButton";
import {
  PHONE_PREFIX,
  validatePassword,
  validatePhoneNumber,
} from "../utils/constant";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import { userPool } from "../utils/aws";
import toastMessage from "../utils/toastMessage";
import LoadingModal from "../Components/AllModal/LoadingModal";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";

function Register() {
  const [form] = Form.useForm();
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleCreateAccount = (values) => {
    console.log(values, " = values:createAccount");

    let attributeList = [
      new CognitoUserAttribute({ Name: "name", Value: values.name }),
      new CognitoUserAttribute({ Name: "email", Value: values.email }),
      new CognitoUserAttribute({
        Name: "phone_number",
        Value: values.prefix + values.phone,
      }),
    ];

    setLoading(true);
    userPool.signUp(
      values.email,
      values.password,
      attributeList,
      null,
      function (err, result) {
        if (err) {
          console.log(err);
          toastMessage(err.message, "error");
          // checkEmailVerifyOrNot(email, password, handleCheckEmailVerifiedOrNot)
          // setLoading(prev => ({ ...prev, signUpLoading: false, }));
          setLoading(false);
          return;
        }
        var cognitoUser = result.user;
        console.log(cognitoUser, "cognitoUser");
        console.log("user name is " + cognitoUser.getUsername());
        // setCurrentTabs(TABS_DATA[1])
        // localStorage.setItem("m3_user_id", cognitoUser.getUsername());
        toastMessage("Successfully Signup", "success");
        localStorage.setItem(
          "username",
          values.email || cognitoUser.getUsername()
        );
        setLoading(false);
        Navigate("/verify-email");
      }
    );
  };

  const phonePrefixOption = PHONE_PREFIX?.map((prefix) => (
    <Option key={prefix} value={prefix}>
      {prefix}
    </Option>
  ));

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: "transparent",
            colorIcon: "white",
            colorIconHover: "white",
            colorTextPlaceholder: "#DADADA",
          },
          Select: {
            optionSelectedColor: "black",
            colorText: "white",
            colorBgContainer: "transparent",
            optionActiveBg: "gray",
            colorBgElevated: "black",
          },
        },
        token: {
          Select: {
            colorIcon: "white",
            colorBgElevated: "white",
          },
        },
      }}
    >
      {/* {loading && <LoadingModal className="bg-gray-500/80" />} */}
      <div className="registerContainer bg-darkJungleGreen h-screen flex justify-center items-center text-white">
        <div className="m3_logo_register absolute top-10 left-16">
          <img src={m3_logo} />
        </div>
        <div className="bg-black shadow-signupBoxShadow px-10 py-5 rounded-2xl w-[494px]">
          <h1 className="font-bold bg-signupTextBg inline-block text-transparent bg-clip-text text-2xl">
            Sign up
          </h1>
          <p>Create New account and join M3 !</p>
          <Form
            form={form}
            className=" text-white"
            name="basic"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              password: "",
              prefix: "+86",
            }}
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
            onFinish={handleCreateAccount}
          >
            <Form.Item
              label="Name"
              name="name"
              style={{ color: "white" }}
              rules={[
                {
                  required: true,
                  message: "Please input your Name!",
                },
              ]}
            >
              <Input placeholder="Enter your full name" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              style={{ color: "white" }}
              rules={[
                {
                  required: true,
                  message: "Please input your Email!",
                },
                {
                  type: "email",
                  message: "Please Enter Correct Email!",
                },
              ]}
            >
              <Input placeholder="mail@simmmple.com" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
                validatePassword,
              ]}
            >
              <Input.Password placeholder="Enter Password Min of 8 characters" />
            </Form.Item>
            <div className="flex gap-x-3">
              <Form.Item
                name="prefix"
                // label="Phone Number"
                style={{ width: "80px", borderRadius: "5px" }}
                rules={[
                  {
                    required: true,
                    message: "Please select your country code!",
                  },
                ]}
              >
                <Select
                  className="select-before"
                  defaultValue={"+86"}
                  suffixIcon={<DownOutlined style={{ color: "white" }} />}
                >
                  {phonePrefixOption}
                </Select>
              </Form.Item>

              <Form.Item
                name="phone"
                // label="Phone Number"
                style={{ width: "100%" }}
                rules={[
                  {
                    required: true,
                    message: "Please input your phone number!",
                  },
                  { validator: validatePhoneNumber },
                ]}
              >
                <Input placeholder="123456789" />
              </Form.Item>
            </div>
            <p>
              Already have an account?{" "}
              <span
                onClick={() => Navigate("/signin")}
                className="text-darkOrange cursor-pointer"
              >
                Login
              </span>
            </p>
            {/* <Divider>or</Divider> */}
            <div className="flex flex-col gap-3">
              {/* <Button
                className="p-3 rounded-3xl flex justify-center items-center border-none bg-darkJungleGreen text-white"
                icon={<Google_original />}
              >
                Sign in with Google
              </Button>
              <Button
                className="p-3 rounded-3xl flex justify-center items-center border-none bg-darkJungleGreen text-white"
                icon={<Linkedin_original />}
              >
                Sign in with LinkedIn
              </Button> */}
              <Form.Item className="mb-0 mt-2">
                <GradientButton
                  className="bg-signupSubmitBtn w-full rounded-3xl"
                  // type="primary"
                  type="submit"
                  disabled={loading}
                >
                  <span>Create new account</span>
                  {loading && (
                    <span>
                      <LoadingOutlined
                        style={{ fontSize: 20, color: "white" }}
                      />
                    </span>
                  )}
                </GradientButton>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default Register;
